<template>
<svg width="60px" height="60px" 
     fill="none"
     viewBox="-5 -5 60 60" xmlns="http://www.w3.org/2000/svg">
  <path style="fill:none;stroke:#ea0000;stroke-width:2.41544;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m14.984 14.932 8.86-4.51 8.678 4.27.008 13.396-17.503.003-.043-13.159"/>
  <path style="fill:none;stroke:#000;stroke-width:2.41544;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.988235" d="m2.705 22.19 8.859-4.51 8.679 4.27.008 13.397-17.503.003-.043-13.16m24.664 0 8.859-4.51 8.679 4.27.007 13.397-17.503.003-.042-13.16"/>
</svg>
</template>
